import Hammer from 'hammerjs';

export default {
    methods: {
        swipe(swipeDirection) {
            const moveOutWidth = document.body.clientWidth * 1.5;
            const card = this.$el;

            if (swipeDirection === 'swipeleft') {
                card.style.transform = 'translateX(-' + moveOutWidth + 'px)';
            } else if (swipeDirection === 'swiperight') {
                card.style.transform = 'translateX(' + moveOutWidth + 'px)';
            }

            if (this.$options.name === 'FoodmashDefaultCard') {
                setTimeout(() => {
                    this.$emit('defaultswiped', swipeDirection);
                }, 300);
            } else if (this.$options.name === 'FoodmashAd') {
                setTimeout(() => {
                    this.$emit('adswiped');
                }, 300);
            } else {
                setTimeout(() => {
                    const payload = {
                        index: this.$vnode.key,
                        swipeDirection
                    };

                    this.$emit('swiped', payload);
                }, 300);
            }
        },
        handlePan(event, card) {
            event.preventDefault();

            if (Math.abs(event.deltaX) < 10) return;
            if (event.center.x === 0 && event.center.y === 0) return;

            if (new window.MobileDetect(window.navigator.userAgent).mobile()) {
                document.body.style.overflow = 'hidden';
            }

            card.classList.add('moving');

            card.parentElement.parentElement.classList.toggle('foodmash-love', event.deltaX > 0);
            card.parentElement.parentElement.classList.toggle('foodmash-nope', event.deltaX < 0);

            card.style.transform = 'translateX(' + event.deltaX + 'px)';
        },
        handlePanEnd(event, card) {
            event.preventDefault();

            if (new window.MobileDetect(window.navigator.userAgent).mobile()) {
                document.body.style.overflow = '';
            }

            card.classList.remove('moving');
            card.parentElement.parentElement.classList.remove('foodmash-love');
            card.parentElement.parentElement.classList.remove('foodmash-nope');

            let keep = Math.abs(event.deltaX) < 80 || Math.abs(event.velocityX) < 0.5;

            if (keep) {
                card.style.transform = '';
            } else {
                this.swipe(event.deltaX > 0 ? 'swiperight' : 'swipeleft');
            }
        },
        getBaseUrl: function () {
            return window.location.protocol + "//" + window.location.hostname;
        }
    },
    mounted() {
        let card = this.$el;
        const hammertime = new Hammer(card);

        hammertime.on('pan', (e) => {
            this.panning = true;
            this.shouldRun = false;
            this.handlePan(e, card);
        });

        hammertime.on('panend', (e) => {
            this.panning = false;
            this.handlePanEnd(e, card);
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/cardMixin.js